// Webpack Imports
import 'bootstrap'
import 'bootstrap/js/dist/modal'
import 'slick-carousel'
import Search from './js/modules/Search'

// Vars
const body = document.getElementsByTagName('body')[0]
const naviToggle = document.getElementById('navi-toggle')
const naviBackground = document.getElementById('navBack')
const header = document.getElementById('header')
var liveSearch = new Search()

window.addEventListener('load', function (event) {
  naviToggle.checked = false
})

// Menu Toggle Button
naviToggle.addEventListener('click', () => {
  if (naviToggle.checked) {
    body.style.overflowY = 'hidden'
    naviBackground.style.transform = 'scale(80)'
    body.classList.add('menu-open')
  } else {
    body.style.overflowY = 'visible'
    naviBackground.style.transform = 'scale(0)'
    body.classList.remove('menu-open')
  }
})

// Shrink Header
const mediaQuery = window.matchMedia('(min-width: 992px)')
window.onscroll = function () {
  scrollFunction()
}

function scrollFunction() {
  if (mediaQuery.matches) {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      header.style.height = '5.5rem'
      document.querySelector('.search-overlay__top').style.marginTop = '5.5rem'
    } else {
      header.style.height = '7.5rem'
      document.querySelector('.search-overlay__top').style.marginTop = '7.5rem'
    }
  }
}

;(function ($) {
  $('.parts__slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: true,
    cssEase: 'linear',
    pauseOnHover: false,
    // variableWidth: true,
    prevArrow: false,
    nextArrow: false,
    prevArrow: $('.parts__slider__nav--left'),
    nextArrow: $('.parts__slider__nav--right'),
    responsive: [
      {
        centerMode: true,
        cssEase: 'linear',
        pauseOnHover: false,
        centerMode: true,
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        centerMode: true,
        cssEase: 'linear',
        pauseOnHover: false,
        centerMode: true,
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        centerMode: true,
        cssEase: 'linear',
        pauseOnHover: false,
        centerMode: true,
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })

  $('#registerModal').on('show.bs.modal', function (event) {
    setTimeout(function () {
      $('#modalFooter').slick({
        autoplay: true,
        centerMode: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        dots: false,
        prevArrow: false,
        nextArrow: false
      })
    }, 0)
  })

  $('#modalFooter').slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    dots: false,
    prevArrow: false,
    nextArrow: false
  })

  $('#headerFooter').slick({
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 768,
        settings: {
          autoplay: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          pauseOnHover: false,
          dots: false,
          prevArrow: false,
          nextArrow: false
        }
      }
    ]
  })

  $('.brands__text').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 0,
    variableWidth: true,
    slidesToShow: 9,
    cssEase: 'linear',
    pauseOnHover: true,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false
  })
})(jQuery)
